import {
  type CurrencyType,
  formatCurrencyAmount,
  getBtcUnit,
} from "@workspace/currency";
import type { FC } from "react";
import CurrencyIcon from "./CurrencyIcon";
import PlayingIndicator from "./PlayingIndicator";

type Props = {
  currency: string;
  cashierBalance: number;
  /* From the cashier-admin currency config. Missing values use the fallbacks. */
  type?: CurrencyType | null;
  maximumFractionDigits?: number | null;
  isPlaying?: boolean;
  playingPhrase?: string;
  isUbtcEnabled?: boolean;
};

const BalanceDisplay: FC<Props> = ({
  currency,
  cashierBalance,
  type,
  maximumFractionDigits,
  isPlaying,
  playingPhrase,
  isUbtcEnabled = false,
}) => {
  const isBtc = currency === "BTC";
  const { value: formatted, code } = formatCurrencyAmount({
    amount: cashierBalance,
    currency,
    type,
    maximumFractionDigits,
    unit: isBtc ? getBtcUnit(isUbtcEnabled) : undefined,
  });
  const btcUnitLabel = isBtc ? code : undefined;

  const playingLabel =
    playingPhrase && playingPhrase !== "" ? playingPhrase : "Playing...";

  return (
    <>
      {isPlaying ? <PlayingIndicator /> : <CurrencyIcon currency={currency} />}
      <span className="text-sm font-medium leading-none tracking-tight text-foreground">
        {isPlaying ? playingLabel : formatted}
      </span>
      {btcUnitLabel && !isPlaying && (
        <span className="text-xs font-medium leading-none tracking-tight text-muted-foreground">
          {btcUnitLabel}
        </span>
      )}
    </>
  );
};

export default BalanceDisplay;
